// @vendors
const get = require('lodash/object/get');
const reduce = require('lodash/collection/reduce');
const trim = require('lodash/string/trim');
const moment = require('moment');
const momentTz = require('moment-timezone');
const Immutable = require('immutable');

// @helpers
const apiURLBuilder = require('../core/apiURLBuilder');
const actionTypes = require('constants/actionTypes');
const { getConfirmationPDFSharesAmount } = require('utilities/pdfDocumentsHelper');
const {
    BROKER_ORDER_TYPE_BUY,
    BROKER_PRODUCT_TYPE_STOCKS,
    CHARGE_ACCOUNT_PREFIX,
    WIZARD_SECOND_STEP,
    WIZARD_THIRD_STEP,
    FIRST_STEP,
    SECOND_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID,
    BROKER_CONDITIONAL_ORDER_TERM,
    FOR_THE_BEST_ORDER_CLASS,
    LIMITED_ORDER_CLASS,
    TO_MARKET_ORDER_CLASS,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_ORDER_TYPE_TO_MARKET,
    EURO_TEXT,
    BROKER_STOCK_ORDER_CONDITION_VALUE,
    IBEX35_SPC_SYMBOL,
    IBEX35_MARKET_CODE,
    BROKER_SYSTEM_NAME,
    CONNECTION_CHANNEL_INTERNET,
    BROKER_MIFID_VERSION_2,
    BROKER_ORDER_TYPE_FOR_THE_BEST_DESCRIPTION,
    BROKER_ORDER_TYPE_LIMITED_DESCRIPTION,
    BROKER_ORDER_TYPE_TO_MARKET_DESCRIPTION,
    DATE_FORMAT_API,
    INTERVENER_TYPE_PROPIETARIO,
    BROKER_ALERT_BUY_BUTTON_STOCK,
    BROKER_TYPE_STOCKS_NEW_DECIMALS_ROUNDER,
    BROKER_MIFID_STOCK_PDF_AMOUNT_DECIMALS,
    API_CHANNEL
} = require('constants/index');
const translateExantCostKey = require('utilities/translationExantCost');

// @utilities
const { APIPost } = require('utilities/APIRequestHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { es: { DATE_FORMAT_WITH_DASHES_DATETIME }} = require('commonsConstants/dateFormatTypes');
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const errorActions = require('actions/brokerError');
const { outdateGlobalPosition } = require('actions/myGlobalPosition');
const { outdateMyInvestments } = require('actions/brokerMyInvestments');
const brokerIntervenerActions = require('actions/brokerInterveners');
const { brokerStocksOperationFailure } = require('actions/brokerStocksOperationFailure');

function reset() {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_RESET
    };
}

function setVisibleStep(step) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

function setWillCancel(value) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_WILL_CANCEL,
        payload: {
            value
        }
    };
}

function validateUIStep(step, catalogData) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_VALIDATE_UI_STEP,
        payload: {
            step,
            catalogData
        }
    };
}

function signaturePatternSuccess(token) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_SIGNATURE_SUCCESS,
        payload: {
            token
        }
    };
}

function confirmStocksBuyRequest() {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_CONFIRM_REQUEST
    };
}

function confirmStocksBuySuccess() {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_CONFIRM_SUCCESS
    };
}

function confirmStocksBuyFailure(response) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_CONFIRM_FAILURE,
        payload: {
            data: response
        }
    };
}

function storeOrderSummaryRequest() {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_STORE_ORDER_REQUEST
    };
}

function storeOrderSummarySuccess() {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_STORE_ORDER_SUCCESS
    };
}

function storeOrderSummaryError() {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_STORE_ORDER_ERROR
    };

}

const generateMiFIDDisclaimers = (immBrokerConvenienceMiFIDTest) => {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
    const immAllDisclaimers = Immutable.fromJS([]).merge(immUSPersonDisclaimers).merge(immDisclaimers);

    return immAllDisclaimers.map(immDisclaimer => immDisclaimer.get('description')).join(' | ');
};

const getHolders = (contract, interveners) => {
    let holderNames = [];
    if (interveners.size > 0) {
        const holders = interveners.filter((intervener) => {
            return intervener.get('tipoIntervencion').trim() === INTERVENER_TYPE_PROPIETARIO
        });
        holderNames = holders.map(holder => {
            return holder.get('nomInterviniente').trim()
        });
    } else {
        const holder = contract.get('walletTitular');
        holderNames.push(holder)
    }
    return holderNames;
}

const storeOrderSummary = (response) => (dispatch, getState) => {
    let communicationServiceInput, data;
    const immProfile = getState().profile;
    const immBrokerProductFile = getState().brokerProductFile;
    const immBrokerStocksAdvancedBuy = getState().brokerStocksAdvancedBuy;
    const immFeatureFlags =  getState().flagBasedFeatures;
    const validationServiceResponse = immBrokerStocksAdvancedBuy.get('validationServiceResponse');
    const step2 = immBrokerStocksAdvancedBuy.getIn(['steps', SECOND_STEP]);
    const selectedOption = step2.get('selectedOptionValue');
    const contract = getState().brokerStocksContract.get(selectedOption);
    const contractNumber = contract.get('walletNumber');
    const productNumber = contract.get('productNumber');
    const controlDigit = contract.get('controlDigit');
    const securityAccount = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${contractNumber}`;
    const marketName = immBrokerProductFile.get('marketName');
    const orderTypeOption = step2.get('orderTypeOption');
    const validityDate = moment(step2.get('validityDate')).format(DATE_FORMAT_API);
    const shareNumber = validationServiceResponse.get('ntitulos');
    const productAmount = Number(immBrokerProductFile.getIn(['productValue','amount'])) || 0;
    const isLimitedOrder = orderTypeOption === BROKER_ORDER_TYPE_LIMITED;
    const sharesAmount = getConfirmationPDFSharesAmount({
        isLimitedOrder,
        sharesNumber: shareNumber,
        lastPrice: productAmount,
        decimals: BROKER_MIFID_STOCK_PDF_AMOUNT_DECIMALS
    });
    const emittedDateTime = momentTz(parseInt(get(response, 'timestamp', ''), 10)).tz("Europe/Madrid");
    const interveners = getState().brokerInterveners.get('list');
    const holderNames = getHolders(contract, interveners);
    const conditionPrice = step2.get('orderTypeValue', ) ? step2.get('orderTypeValue') : '';

    const showExAnteCost = immFeatureFlags.get('wealth_stocks_buy_show_costs');
    const immExanteData = immBrokerStocksAdvancedBuy.get('exAnteData');
    const exantCostsData = !!immExanteData.getIn(["exAnteCostList"])
        ? translateExantCostKey(
              immExanteData.getIn(["exAnteCostList"]).toJS(),
              "brokerBuyStockExAnte",
              "PROFITABILITY",
              "brokerBuyStockExAnteProfitability"
          )
        : null;

    communicationServiceInput = {
        "email":PersonalDataHelper.getEmail(immProfile),
        "idContract": securityAccount,
        "productKID":"",
        "contract": "",
        "marketingReport": "",
        "infoCcv": "",
        "sendOrder": "No",
        "clientAlias": immProfile.get('nombreCliente'),
        "isin": immBrokerStocksAdvancedBuy.get('isin'),
        "isinDescribe": immBrokerProductFile.get('companyName'),
        "idOrder" :   get(response, 'numeroOrden', ''),
        "channel" : CONNECTION_CHANNEL_INTERNET,
        "orderType" : BROKER_ORDER_TYPE_BUY,
        "productType" : BROKER_PRODUCT_TYPE_STOCKS,
        "holders" : holderNames.join(','),
        "ccv" : securityAccount,
        "ccc": get(response, ['cuentaAsociada', 'codbban'], '').trim(),
        "market" : marketName,
        "sharesNumber": "" + shareNumber + "",
        "orderCondition": "",
        "sharesAmount" : sharesAmount,
        "termValidity" : validityDate,
        "conditionPrize" : "" + conditionPrice + "",
        "currency":  immBrokerStocksAdvancedBuy.get('productCurrency'),
        "mifidWarningText": generateMiFIDDisclaimers(getState().brokerConvenienceMiFIDTest),
        "dateTime" : emittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME)
    };

    switch (orderTypeOption) {
        case BROKER_ORDER_TYPE_FOR_THE_BEST:
            communicationServiceInput.orderCondition = BROKER_ORDER_TYPE_FOR_THE_BEST_DESCRIPTION;
            break;
        case BROKER_ORDER_TYPE_LIMITED:
            communicationServiceInput.orderCondition = BROKER_ORDER_TYPE_LIMITED_DESCRIPTION;
            break;
        case BROKER_ORDER_TYPE_TO_MARKET:
            communicationServiceInput.orderCondition = BROKER_ORDER_TYPE_TO_MARKET_DESCRIPTION;
            break;
    }


    if (showExAnteCost) {
        const estimatedBaseAmount = immExanteData.getIn([
            "estimatedBaseAmount",
            "amount",
        ])
            ? immExanteData.getIn(["estimatedBaseAmount", "amount"])
            : null;
        data = {
            query: {
                ...communicationServiceInput,
                sharesAmount: estimatedBaseAmount,
                exAnteCostsList: exantCostsData
            }
        };
    } else {
        data = {
            query: communicationServiceInput
        };
    }

    dispatch(storeOrderSummaryRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('communication'), data).then(
        function () {
            dispatch(storeOrderSummarySuccess());
        },
        function () {
            dispatch(storeOrderSummaryError());
        }
    );
}

const mifidDisclaimersResponse = (immBrokerConvenienceMiFIDTest) => {
    const isUsingMifidv2 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_2;
    let disclaimers = undefined;

    if (isUsingMifidv2) {
        const mifidv2AllDisclaimers =
            immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers'])
            .merge(immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']))
            .toJS();

        disclaimers = reduce(mifidv2AllDisclaimers, (result, disclaimer, index) => {
            const disclaimerKey = `disclaimer_${index + 1}`;
            const disclaimerText = trim(get(disclaimer, 'description'));

            result[disclaimerKey] = `${trim(get(disclaimer, 'id'))} | ${disclaimerText}`;

            return result;
        }, {});
    }

    return disclaimers;
};

function getConfirmationRequestObject(getState) {
    //Hardcoded service params
    //TODO: move to constants file if they are needed somewhere else
    const NUM_EJECUCIONES = 1;
    const ID_ACCION = 'COS';
    const TIPO_EJECUCION = 0;
    const TIPO_OPERACION = 'C';
    const TIPO_PRECIO = 'T';

    const immStocksContract = getState().brokerStocksContract;
    const immBrokerStocksAdvancedBuy = getState().brokerStocksAdvancedBuy;
    const immBrokerProductFile = getState().brokerProductFile;
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const uuid = immBrokerLegalDocumentation.get('uuid');

    const step1 = immBrokerStocksAdvancedBuy.getIn(['steps', FIRST_STEP]);
    const step2 = immBrokerStocksAdvancedBuy.getIn(['steps', SECOND_STEP]);
    const validationServiceResponse = immBrokerStocksAdvancedBuy.get('validationServiceResponse');
    const productCurrency = immBrokerStocksAdvancedBuy.get('productCurrency');
    const orderConditionValue = step1.get('orderConditionValue');
    const selectedOptionValue = step2.get('selectedOptionValue');
    const selectedStockContract = immStocksContract.get(selectedOptionValue);
    const orderTypeOption = step2.get('orderTypeOption');
    const orderTypeValue = step2.get('orderTypeValue');
    const titleQuantity = step2.get('titleQuantity');
    const conditionType = step1.get('conditionType');
    const conditionTypeValue = step1.get('conditionTypeValue');
    const stockSpcSymbol = immBrokerProductFile.get('spcSymbol');
    const stockLast = immBrokerProductFile.getIn(['productValue','amount']);
    const exchangeId = step1.get('exchangeId');
    const validityDate = step1.get('validityDate');
    const codigoDisclaimer = getState().brokerMiFIDProducts.getIn(['products', BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID, 'codigoDisclaimer']);
    const shares = validationServiceResponse.get('ntitulos');
    let spcSymbol = IBEX35_SPC_SYMBOL;
    let marketCode = IBEX35_MARKET_CODE;
    const micCode = immBrokerProductFile.get('micCode');

    if (orderConditionValue === BROKER_STOCK_ORDER_CONDITION_VALUE) {
        spcSymbol = stockSpcSymbol;
        marketCode = exchangeId;
    }

    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const mifidScore = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'score']);
    const mifidScoring = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'scoring']);
    const mifidWasApplied = immBrokerConvenienceMiFIDTest.get('started');

    const requestObject = {
        header: {
            'version': 2
        },
        query: {
            codEmis: validationServiceResponse.get('codigoEmision'),
            codGrupoSector: validationServiceResponse.get('codGrupoSector'),
            codMercado: marketCode,
            codOrganismoEjecucion: validationServiceResponse.get('codOrganismoEjecucion'),
            codOrganismoFusion: validationServiceResponse.get('codOrganismoFusion').trim(),
            codVaint: validationServiceResponse.get('codigoValor'),
            codValorSibCodVLBOL: validationServiceResponse.get('codValorSibCodVLBOL').trim(),
            codigoMoneda: validationServiceResponse.get('codigoMoneda'),
            contratoValores: {
                numerodecontrato: selectedStockContract.get('walletNumber'),
                producto: selectedStockContract.get('productNumber')
            },
            dataToken: immBrokerStocksAdvancedBuy.get('signaturePatternToken'),
            digControCCV: selectedStockContract.get('controlDigit'),
            fechaVencimiento: validityDate.format('YYYY-MM-DD'),
            idAccion: ID_ACCION,
            idCondicion: conditionType,
            identifiMercadoContratacion: validationServiceResponse
                .get('identifiMercadoContratacion')
                .trim(),
            importeAproximado: {
                divisa: EURO_TEXT,
                importe: 0
            },
            indCompras: validationServiceResponse.get('indCompras'),
            indEnvioRecepcion: validationServiceResponse.get('indEnvioRecepcion'),
            indNegocio: validationServiceResponse.get('indNegocio'),
            indTratamientoEmisor: validationServiceResponse.get('indTratamientoEmisor'),
            numEjecuciones: NUM_EJECUCIONES,
            numTitulos: titleQuantity,
            precio: stockLast,
            unitPrice: stockLast,
            simboloEmision: spcSymbol.trim(),
            sistema: BROKER_SYSTEM_NAME,
            tipoCotizacion: validationServiceResponse.get('tipoCotizacion'),
            tipoEjecucion: TIPO_EJECUCION,
            tipoMercado: validationServiceResponse.get('tipoMercado'),
            tipoOperacion: TIPO_OPERACION,
            tipoPrecio: TIPO_PRECIO,
            valorCondicion: parseFloat(Math.round(conditionTypeValue * BROKER_TYPE_STOCKS_NEW_DECIMALS_ROUNDER) / BROKER_TYPE_STOCKS_NEW_DECIMALS_ROUNDER).toFixed(3),
            valorJuntaSindical: validationServiceResponse.get('valorJuntaSindical'),
            precioLimitada: {
                divisa: 'EUR',
                numeroimportevalores: 0
            },
            shares: shares,
            initQuantity: shares,
            micCode: micCode,
            convenienceTest: codigoDisclaimer,
            productIsin: immBrokerStocksAdvancedBuy.get('isin'),
            productManager: getState().brokerProductFile.get('manager'),
            convenientRegistry: immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'isConvenient']),
            evaluateRegistry: mifidWasApplied,
            disclaimers: mifidDisclaimersResponse(immBrokerConvenienceMiFIDTest),
            marketTargetRegistry: mifidScore >= mifidScoring,
            necessaryConvenienceTestNote: mifidScoring,
            necessaryTargetMarketNote: immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'targetMarketKnowledgeAndExperience']),
            testConveniencyResult: mifidScore,
            productType: BROKER_ALERT_BUY_BUTTON_STOCK,
            documentationId: uuid
        }
    };

    switch (orderTypeOption) {
        case BROKER_ORDER_TYPE_FOR_THE_BEST:
            requestObject.query.indOrdenBolsa = FOR_THE_BEST_ORDER_CLASS;
            break;
        case BROKER_ORDER_TYPE_LIMITED:
            requestObject.query.indOrdenBolsa = LIMITED_ORDER_CLASS;
            break;
        case BROKER_ORDER_TYPE_TO_MARKET:
            requestObject.query.indOrdenBolsa = TO_MARKET_ORDER_CLASS;
            break;
    }

    if (orderTypeOption === BROKER_ORDER_TYPE_LIMITED) {
        requestObject.query.precioLimitada = {
            divisa: productCurrency,
            numeroimportevalores: orderTypeValue
        };
    }

    return requestObject;
}

function confirmStocksBuy(history) {
    return function(dispatch, getState) {
        const data = getConfirmationRequestObject(getState);

        dispatch(confirmStocksBuyRequest());
        return APIPost(
            dispatch,
            apiURLBuilder.getURL('brokerConditionalStocksBuyConfirmation'),
            data
        ).then(
            function(response) {
                dispatch(storeOrderSummary(response));
                dispatch(confirmStocksBuySuccess());
                dispatch(outdateGlobalPosition());
                dispatch(outdateMyInvestments());
            },
            function(response) {
                dispatch(confirmStocksBuyFailure(response));
                dispatch(brokerStocksOperationFailure(response, history));
            }
        );
    };
}


function orderTermsChanged(value) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_ORDER_TERMS_CHANGED,
        payload: {
            value
        }
    };
}

const inputSearchProductSelected = product => {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_INPUT_SEARCH_PRODUCT_SELECTED,
        payload: {
            currencyCode: product.currencyCode,
            value: product.value,
            isin: product.id.isin,
            iso: product.id.iso,
            spcSymbol: product.spcSymbol,
            last: product.last,
            exchangeId: product.exchangeId
        }
    };
};

function inputSearchProductReset() {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_INPUT_SEARCH_PRODUCT_RESET
    };
}

const orderConditionValueChanged = value => {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_ORDER_CONDITION_VALUE_CHANGED,
        payload: {
            value
        }
    };
};

const conditionTypeChanged = value => {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_ORDER_CONDITION_TYPE_CHANGED,
        payload: {
            value
        }
    };
};

const conditionTypeValueChanged = value => {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_CONDITION_TYPE_VALUE_CHANGED,
        payload: {
            value
        }
    };
};

const validityDateChanged = value => {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_VALIDITY_DATE_CHANGED,
        payload: {
            value
        }
    };
};

const orderTermValidityDateChanged = value => {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_ORDER_TERM_VALIDITY_DATE_CHANGED,
        payload: {
            value
        }
    };
};

function stockContractChanged(value) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_STOCK_CONTRACT_CHANGED,
        payload: {
            value
        }
    };
}

function titleQuantityChanged(value) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_TITLE_QUANTITY_CHANGED,
        payload: {
            value
        }
    };
}

function orderTypeChanged(value) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_ORDER_TYPE_CHANGED,
        payload: {
            value
        }
    };
}

function limitedValueChanged(value) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_LIMITED_VALUE_CHANGED,
        payload: {
            value
        }
    };
}

function setLimitedValueCurrency(value) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_SET_LIMITED_VALUE_CURRENCY,
        payload: {
            value
        }
    };
}

function validateWithAPISuccess(step, response) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_VALIDATE_SUCCESS,
        payload: {
            data: response,
            step
        }
    };
}

function validateWithAPIFailure(step, response) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_VALIDATE_FAILURE,
        payload: {
            data: response,
            step
        }
    };
}

function validateWithAPIRequest(step) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_VALIDATE_REQUEST,
        payload: {
            step
        }
    };
}

const getValidationRequestObject = getState => {
    const immStocksContract = getState().brokerStocksContract;
    const immBrokerStocksAdvancedBuy = getState().brokerStocksAdvancedBuy;

    const step1 = immBrokerStocksAdvancedBuy.getIn(['steps', FIRST_STEP]);
    const step2 = immBrokerStocksAdvancedBuy.getIn(['steps', SECOND_STEP]);
    const selectedOptionValue = step2.get('selectedOptionValue');
    const validityDate = step1.get('validityDate');
    const selectedStockContract = immStocksContract.get(selectedOptionValue);
    const orderTypeOption = step2.get('orderTypeOption');
    const orderTypeValue = step2.get('orderTypeValue');
    const titleQuantity = step2.get('titleQuantity');
    const isin = immBrokerStocksAdvancedBuy.get('isin');
    const iso = immBrokerStocksAdvancedBuy.get('iso');

    const requestObject = {
        query: {
            codigoISIN: isin,
            codigoISO: iso,
            contratoValores: {
                numerodecontrato: selectedStockContract.get('walletNumber'),
                producto: selectedStockContract.get('productNumber')
            },
            digitoControlCCV: selectedStockContract.get('controlDigit'),
            fechaLimite: validityDate.format('YYYY-MM-DD'),
            importeAproximado: {
                divisa: EURO_TEXT,
                numeroimportevalores: 0
            },
            titulos: titleQuantity
        }
    };

    switch (orderTypeOption) {
        case BROKER_ORDER_TYPE_FOR_THE_BEST:
            requestObject.query.clase = FOR_THE_BEST_ORDER_CLASS;
            break;
        case BROKER_ORDER_TYPE_LIMITED:
            requestObject.query.clase = LIMITED_ORDER_CLASS;
            requestObject.query.precioLimitada = orderTypeValue;
            break;
        case BROKER_ORDER_TYPE_TO_MARKET:
            requestObject.query.clase = TO_MARKET_ORDER_CLASS;
            break;
    }

    return requestObject;
};
const getInterveners = () => (dispatch, getState) => {
    const immStocksContract = getState().brokerStocksContract;
    const immBrokerStocksAdvancedBuy = getState().brokerStocksAdvancedBuy;
    const step2 = immBrokerStocksAdvancedBuy.getIn(['steps', SECOND_STEP]);
    const selectedOptionValue = step2.get('selectedOptionValue');
    const selectedStockContract = immStocksContract.get(selectedOptionValue);
    const wallet = Immutable.fromJS({
        accountNumber: selectedStockContract.get('walletNumber'),
        product:  selectedStockContract.get('productNumber')
    })
    dispatch(brokerIntervenerActions.getIndexes(wallet));
}
const validateConditionalOrderWithAPI = (step, history) => (dispatch, getState) => {
    const valid = getState().brokerStocksAdvancedBuy.getIn(['steps', FIRST_STEP, 'valid']);

    if (valid) {
        const data = getValidationRequestObject(getState);

        dispatch(validateWithAPIRequest(step));
        return APIPost(
            dispatch,
            apiURLBuilder.getURL('brokerConditionalStocksBuyValidation'),
            data
        ).then(
            function(response) {
                dispatch(validateWithAPISuccess(step, response));
                dispatch(getInterveners());
            },
            function(response) {
                dispatch(validateWithAPIFailure(step, response));
                const errorKey = get(response, ['body', 'error'], '');
                dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
            }
        );
    }
};

const validateRestrictedOrderWithAPI = () => {
    //TODO: implement me !
};

const validateWithAPI = (orderTerms, step, history) => dispatch => {
    if (orderTerms === BROKER_CONDITIONAL_ORDER_TERM) {
        dispatch(validateConditionalOrderWithAPI(step, history));
    } else {
        dispatch(validateRestrictedOrderWithAPI());
    }
};

function setOrderID(isin, iso) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_SET_ORDER_ID,
        payload: {
            isin,
            iso
        }
    };
}

const requestSignaturePatternValidation = (history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        dispatch(signaturePatternSuccess(dataToken));
        dispatch(confirmStocksBuy(history));
    };
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

const finish = (history) => dispatch => {
    dispatch(requestSignaturePatternValidation(history));
};

const validateStep = (step, history) => (dispatch, getState) => {
    const catalogData = getState().brokerProductFile.get('catalogData');
    dispatch(validateUIStep(step, catalogData));
    if (step === WIZARD_SECOND_STEP) {
            if (getState().brokerStocksAdvancedBuy.getIn(['steps', SECOND_STEP, 'valid'])) {
                const orderTerms = getState().brokerStocksAdvancedBuy.getIn([
                    'steps',
                    FIRST_STEP,
                    'orderTerms'
                ]);
                dispatch(validateWithAPI(orderTerms, step, history));
            }
    }
    else if (step === WIZARD_THIRD_STEP) {
        dispatch(finish(history));
    }

};

function extantCostRequest() {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_EXANT_COST_FETCHING,
    };
}

function extantCostSuccess(data) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_EXANT_COST_SUCCESS,
        payload: data
    };
}

function extantCostError(error) {
    return {
        type: actionTypes.BROKER_STOCKS_ADVANCED_BUY_EXANT_COST_ERROR,
        payload: error
    };
}


const getExtantCostDetails = () => (dispatch, getState) => {
    const brokerStocksAdvancedBuy = getState().brokerStocksAdvancedBuy;
    const immStepTwo = brokerStocksAdvancedBuy.getIn(['steps', SECOND_STEP]);
    let limitedPrice = null;
    let orderType;

    const sharesAmount = null;
    const sharesNumber = immStepTwo.get('titleQuantity');
    const orderTypeOption = immStepTwo.get('orderTypeOption');

    switch (orderTypeOption) {
        case 'toMarket':
            orderType = 'MARKET';
            break;
        case 'forTheBest':
            orderType = 'BEST';
            break;
        case 'limited':
            orderType = 'LIMITED';
            limitedPrice = {
                amount: immStepTwo.get('orderTypeValue'),
                currency: getState().brokerProductFile.get('currency'),
                descriptionKey: null,
                percentage: null,
                tooltipKey: null,
                type: null
            }
            break;
    }
    const immStocksContract = getState().brokerStocksContract;
    const selectedOption = immStepTwo.get('selectedOptionValue');
    const contract = immStocksContract.get(selectedOption);
    const channelForRequest = __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL;

    const requestData = {
        channel: channelForRequest,
        contract: {
          number: contract.get('walletNumber'),
          product: contract.get('productNumber')
        },
        instrumentType: 'STOCK',
        isin: getState().brokerProductFile.get('isinCode'),
        limitedPrice,
        market: getState().brokerProductFile.get('micCode'),
        operationType: 'C',
        orderType,
        sharesAmount,
        sharesNumber
    }

    dispatch(extantCostRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerGetExAnteCost'), { query: requestData }).then(
        function (response) {
            dispatch(extantCostSuccess(response));
        },
        function (error) {
            const errorKey = get(error, ['body', 'error'], '') || error.error;
            dispatch(extantCostError(error));
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey));
        }
    );
}

module.exports = {
    reset,
    setVisibleStep,
    setWillCancel,
    validateStep,
    finish,
    orderTermsChanged,
    inputSearchProductSelected,
    inputSearchProductReset,
    orderConditionValueChanged,
    conditionTypeChanged,
    conditionTypeValueChanged,
    validityDateChanged,
    orderTermValidityDateChanged,
    stockContractChanged,
    titleQuantityChanged,
    orderTypeChanged,
    limitedValueChanged,
    setLimitedValueCurrency,
    setOrderID,
    getExtantCostDetails,
};
